/** What a full day of logged work looks like.
 *
 *  The daily block exists so somebody can tell, at a glance, whether they put
 *  down their day — so it has to know what a day is. Change this one number if
 *  the expectation changes. */
export const DAILY_TARGET_HOURS = 7.5;

export interface Day {
  /** YYYY-MM-DD */
  day: string;
  minutes: number;
  weekend: boolean;
  /** Short of the target, and a working day, so worth noticing. */
  short: boolean;
}

/** lastDays builds the window backwards from today and fills in what was
 *  logged.
 *
 *  Every day is there, including the ones with nothing on them. A day you
 *  forgot to log has no rows, so a query that groups rows cannot return it —
 *  and a day missing from the list is exactly the day you need to see. */
export function lastDays(totals: { day: string; minutes: number }[], days: number): Day[] {
  const logged = new Map<string, number>();
  for (const t of totals) logged.set(t.day.slice(0, 10), t.minutes);

  const out: Day[] = [];
  const cursor = new Date();
  for (let i = 0; i < days; i++) {
    const key = toKey(cursor);
    const minutes = logged.get(key) ?? 0;
    const weekend = cursor.getDay() === 0 || cursor.getDay() === 6;

    // A Saturday with nothing on it is not a gap, it is a Saturday.
    if (!(weekend && minutes === 0)) {
      out.push({
        day: key,
        minutes,
        weekend,
        short: !weekend && minutes < DAILY_TARGET_HOURS * 60,
      });
    }
    cursor.setDate(cursor.getDate() - 1);
  }
  return out;
}

function toKey(d: Date): string {
  // Local date, not UTC: "today" is the day the person is having.
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}
